(function () {
  "use strict";

// [module] src/runtime/modules/cwv/runtime.mjs
function registerCwvMonitorRuntime() {
  (function () {
    "use strict";

    var themeConfig = (window.__sternTheme && window.__sternTheme.cwv) || {};
    var errorConfig = (window.__sternTheme && window.__sternTheme.errorMonitoring) || {};
    var telemetryConfig = (window.__sternTheme && window.__sternTheme.telemetry) || {};
    var debugEnabled = false;

    try {
      var query = new URLSearchParams(window.location.search || "");
      if (query.get("cwv_debug") === "1") {
        debugEnabled = true;
      }
    } catch (error) {}

    var monitoringEnabled = themeConfig.enabled !== false || debugEnabled;
    var errorMonitoringEnabled = errorConfig.enabled === true || debugEnabled;
    if (!monitoringEnabled) {
      if (!errorMonitoringEnabled) {
        return;
      }
    }

    var routeMeta = {
      path: window.location.pathname,
      href: window.location.href,
      template: window.__sternTheme && window.__sternTheme.template ? window.__sternTheme.template : "",
      pageType: window.__sternTheme && window.__sternTheme.pageType ? window.__sternTheme.pageType : "",
      environment: telemetryConfig.environment || ""
    };

    var metricValues = {};

    function getRating(metricName, value) {
      if (metricName === "LCP") {
        if (value <= 2500) return "good";
        if (value <= 4000) return "needs-improvement";
        return "poor";
      }
      if (metricName === "CLS") {
        if (value <= 0.1) return "good";
        if (value <= 0.25) return "needs-improvement";
        return "poor";
      }
      if (metricName === "INP") {
        if (value <= 200) return "good";
        if (value <= 500) return "needs-improvement";
        return "poor";
      }
      return "unknown";
    }

    function sendMetric(metricName, value, id) {
      if (!value || Number.isNaN(value)) {
        return;
      }

      var previousValue = metricValues[metricName];
      var delta = typeof previousValue === "number" ? value - previousValue : value;
      metricValues[metricName] = value;

      var payload = {
        name: metricName,
        value: metricName === "CLS" ? Number(value.toFixed(4)) : Math.round(value),
        delta: metricName === "CLS" ? Number(delta.toFixed(4)) : Math.round(delta),
        rating: getRating(metricName, value),
        id: id || "",
        timestamp: Date.now(),
        navigationType: (window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType("navigation")[0] && window.performance.getEntriesByType("navigation")[0].type) || "navigate",
        route: routeMeta,
        connection: navigator.connection && navigator.connection.effectiveType ? navigator.connection.effectiveType : ""
      };

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: "theme_cwv",
          metric_name: payload.name,
          metric_value: payload.value,
          metric_delta: payload.delta,
          metric_rating: payload.rating,
          metric_id: payload.id,
          metric_path: payload.route.path,
          metric_template: payload.route.template,
          metric_page_type: payload.route.pageType
        });
      }

      sendBeaconPayload('cwv', payload, themeConfig.beaconUrl);

      if (debugEnabled || themeConfig.console === true) {
        if (window.console && typeof window.console.info === "function") {
          window.console.info("[cwv]", payload);
        }
      }
    }

    function observeLcp() {
      if (!("PerformanceObserver" in window)) {
        return;
      }

      var lcpEntry = null;
      try {
        var lcpObserver = new PerformanceObserver(function (entryList) {
          var entries = entryList.getEntries();
          if (!entries.length) {
            return;
          }
          lcpEntry = entries[entries.length - 1];
        });

        lcpObserver.observe({ type: "largest-contentful-paint", buffered: true });

        var finalizeLcp = function () {
          if (lcpEntry) {
            sendMetric("LCP", lcpEntry.startTime, lcpEntry.id);
          }
          lcpObserver.disconnect();
        };

        document.addEventListener("visibilitychange", function () {
          if (document.visibilityState === "hidden") {
            finalizeLcp();
          }
        }, { once: true });
        window.addEventListener("pagehide", finalizeLcp, { once: true });
      } catch (error) {}
    }

    function observeCls() {
      if (!("PerformanceObserver" in window)) {
        return;
      }

      var clsValue = 0;
      var clsId = "";

      try {
        var clsObserver = new PerformanceObserver(function (entryList) {
          entryList.getEntries().forEach(function (entry) {
            if (entry.hadRecentInput) {
              return;
            }
            clsValue += entry.value;
            clsId = entry.id || clsId;
          });
        });

        clsObserver.observe({ type: "layout-shift", buffered: true });

        var finalizeCls = function () {
          sendMetric("CLS", clsValue, clsId);
          clsObserver.disconnect();
        };

        document.addEventListener("visibilitychange", function () {
          if (document.visibilityState === "hidden") {
            finalizeCls();
          }
        }, { once: true });
        window.addEventListener("pagehide", finalizeCls, { once: true });
      } catch (error) {}
    }

    function observeInp() {
      if (!("PerformanceObserver" in window)) {
        return;
      }

      var inpValue = 0;
      var inpId = "";

      try {
        var inpObserver = new PerformanceObserver(function (entryList) {
          entryList.getEntries().forEach(function (entry) {
            if (!entry || !entry.duration) {
              return;
            }
            var hasInteraction = typeof entry.interactionId === "number" && entry.interactionId > 0;
            if (!hasInteraction) {
              return;
            }
            if (entry.duration > inpValue) {
              inpValue = entry.duration;
              inpId = entry.name || String(entry.interactionId || "");
            }
          });
        });

        inpObserver.observe({ type: "event", buffered: true, durationThreshold: 40 });

        var finalizeInp = function () {
          sendMetric("INP", inpValue, inpId);
          inpObserver.disconnect();
        };

        document.addEventListener("visibilitychange", function () {
          if (document.visibilityState === "hidden") {
            finalizeInp();
          }
        }, { once: true });
        window.addEventListener("pagehide", finalizeInp, { once: true });
      } catch (error) {}
    }

    function sendErrorTelemetry(kind, details) {
      if (!errorMonitoringEnabled) {
        return;
      }

      var payload = {
        kind: String(kind || "error"),
        message: String((details && details.message) || "Unknown error").slice(0, 500),
        source: String((details && details.source) || "").slice(0, 300),
        line: Number((details && details.line) || 0),
        column: Number((details && details.column) || 0),
        stack: String((details && details.stack) || "").slice(0, 4000),
        timestamp: Date.now(),
        route: routeMeta
      };

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: "theme_js_error",
          error_kind: payload.kind,
          error_message: payload.message,
          error_source: payload.source,
          error_line: payload.line,
          error_column: payload.column,
          error_path: payload.route.path,
          error_template: payload.route.template,
          error_page_type: payload.route.pageType
        });
      }

      sendBeaconPayload('error', payload, errorConfig.beaconUrl);

      if (debugEnabled || errorConfig.console === true) {
        if (window.console && typeof window.console.warn === "function") {
          window.console.warn("[theme-error]", payload);
        }
      }
    }

    function bindErrorMonitoring() {
      if (!errorMonitoringEnabled) {
        return;
      }

      window.addEventListener("error", function (event) {
        var err = event && event.error ? event.error : null;
        sendErrorTelemetry("window.error", {
          message: event && event.message ? event.message : "",
          source: event && event.filename ? event.filename : "",
          line: event && event.lineno ? event.lineno : 0,
          column: event && event.colno ? event.colno : 0,
          stack: err && err.stack ? err.stack : ""
        });
      });

      window.addEventListener("unhandledrejection", function (event) {
        var reason = event && event.reason ? event.reason : "";
        var message = "";
        var stack = "";
        if (reason && typeof reason === "object") {
          message = reason.message || String(reason);
          stack = reason.stack || "";
        } else {
          message = String(reason || "Unhandled rejection");
        }
        sendErrorTelemetry("unhandledrejection", {
          message: message,
          stack: stack
        });
      });
    }

    function resolveBeaconEndpoint(kind, specificEndpoint) {
      if (specificEndpoint) {
        return String(specificEndpoint);
      }
      if (!telemetryConfig.endpoint) {
        return "";
      }
      var fallback = String(telemetryConfig.endpoint);
      if (!fallback) {
        return "";
      }
      var separator = fallback.indexOf('?') === -1 ? '?' : '&';
      return fallback + separator + 'type=' + encodeURIComponent(kind);
    }

    function sendBeaconPayload(kind, payload, specificEndpoint) {
      var endpoint = resolveBeaconEndpoint(kind, specificEndpoint);
      if (!endpoint || !navigator.sendBeacon) {
        return;
      }
      try {
        navigator.sendBeacon(endpoint, JSON.stringify(payload));
      } catch (error) {}
    }

    if (monitoringEnabled) {
      observeLcp();
      observeCls();
      observeInp();
    }
    bindErrorMonitoring();
  })();
}

// [module] src/runtime/entries/cwv-monitor.mjs

registerCwvMonitorRuntime();

})();
